/**
 * ver 0.1
 * author jack
 */
import React from 'react'

class DefaultLayer extends React.Component {
    render() {
        return (
            <table id="lyrPop" className="bgdark">
                <tbody><tr><td>
                    <div className="PopMain artPop">
                        <strong>{this.props.children}</strong>
                        {/* <font className="clrpont1">파란글씨 클래스clrpont1</font> */}
                        <div className="popDefBtns">
                            <button className="icon-X_close" onClick={() => this.props.onClose()}></button>
                            <button className="confBtn" onClick={() => this.props.onClose()}>확인</button>
                        </div>
                    </div>
                </td></tr></tbody>
            </table>
        )
    }
}
export default DefaultLayer



// WEBPACK FOOTER //
// ./src/common/container/layer/defaultLayer.js